module.exports = __webpack_public_path__ + "img/banner-kai-pc.92cc021a.png";